import React from 'react';

class FileInput extends React.Component{
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.refs.fileUploader.click();
  }

  render(){
    const { 
      input_type, 
      input_name, 
      input_label, 
      input_value, 
      input_placeholder, 
      input_onChange,
      input_invalid_feedback,
      input_is_required,
      input_parent,
      input_helper,
      input_rows
    } = this.props;

    return(
       
      <div className="form-group">
        <label className="form-control-label">{ this.props.input_label }</label>
           <input 
            className="form-control" 
            ref="fileUploader"
            type="file" 
            name={ input_name } 
            value={ input_value.name } 
            onChange={ input_onChange } 
            placeholder={ input_placeholder } 
            required={ input_is_required }
            data-parent={ input_parent }
            style={{ display: 'none' }}
          />
        <div className="input-group">
          <input 
            type="text" 
            className="form-control" 
            placeholder={ input_placeholder }
            value = { input_value.data && input_value.data.name } 
          />
          <div classNAme="input-group-prepend">
            <button className="input-group-text" onClick={this.handleClick}>Browse</button>
          </div>
        </div>
        <small className="help-block">{input_helper}</small>
        <div className="invalid-feedback">{ input_invalid_feedback }</div>
      </div>
    );
  }
} 

export {FileInput};


// WEBPACK FOOTER //
// ./src/components/FileInput.js